import React, { useState } from 'react';
import HookForm from '../../../../components/HookForm/HookForm';
import Datepicker from '../../../../components/Inputs/Datepicker/Datepicker';
import SelectClientIssuer from '../../../../components/Selects/SelectClientDocumentType';
import { MASK } from '../../../../constants/mask';

const CarSellerForm = ({ onSellerCreated, carData, currentData }) => {
  console.log(currentData)
  const [sellerForm, setSellerForm] = useState([
    {
      name: 'LastName',
      label: 'Ð¤Ð°Ð¼Ð¸Ð»Ð¸Ñ',
      placeholder: '',
      rules: { required: true },
      value: currentData?.LastName,
      defaultValue: currentData?.LastName,
      capitalize: true,
    },
    {
      name: 'FirstName',
      label: 'ÐÐ¼Ñ',
      placeholder: '',
      rules: { required: true },
      value: currentData?.FirstName,
      defaultValue: currentData?.FirstName,
      capitalize: true,
    },
    {
      name: 'MiddleName',
      label: 'ÐÑÑÐµÑÑÐ²Ð¾',
      placeholder: '',
      value: currentData?.MiddleName,
      defaultValue: currentData?.MiddleName,
      capitalize: true,
    },
    {
      name: 'IIN',
      label: 'ÐÐÐ',
      placeholder: '900101300000',
      rules: {
        required: true,
        validate: (value) => {
          if (!value || value.length !== 12) {
            return 'ÐÐÐ Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÑ 12 ÑÐ¸ÑÑ';
          }
          return true;
        }
      },
      mask: MASK.IIN,
      value: currentData?.IIN,
      defaultValue: currentData?.IIN,
    },
    {
      name: 'DOCUMENT_NUMBER',
      label: 'ÐÐ¾Ð¼ÐµÑ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸',
      placeholder: '123456789',
      rules: {
        required: true,
      },
      mask: MASK.DOCUMENT_NUMBER,
      value: currentData?.DOCUMENT_NUMBER,
      defaultValue: currentData?.DOCUMENT_NUMBER,
    },
    {
      name: 'DOCUMENT_GIVED_DATE',
      label: 'ÐÐ°ÑÐ° Ð²ÑÐ´Ð°ÑÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°',
      type: 'date',
      component: Datepicker,
      rules: { required: true },
      value: currentData?.DOCUMENT_GIVED_DATE,
      defaultValue: currentData?.DOCUMENT_GIVED_DATE,
    },
    {
      name: 'DOCUMENT_ISSUED_BY',
      component: SelectClientIssuer,
      label: 'ÐÐµÐ¼ Ð²ÑÐ´Ð°Ð½',
      rules: { required: true },
      defaultValue: currentData?.DOCUMENT_ISSUED_BY,
    },
    {
      name: 'ADDRESS',
      label: 'ÐÐ´ÑÐµÑ',
      placeholder: 'Ð³. ÐÐ»Ð¼Ð°ÑÑ, ÑÐ». ÐÑÐ¸Ð¼ÐµÑÐ½Ð°Ñ, 2',
      rules: { required: true },
      value: currentData?.ADDRESS,
      defaultValue: currentData?.ADDRESS,
    },
    {
      name: 'CONTACT_PHONE',
      label: 'ÐÐ¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°',
      placeholder: '77001234567',
      rules: { required: true },
      value: currentData?.CONTACT_PHONE,
      defaultValue: currentData?.CONTACT_PHONE,
      mask: MASK.PHONE,
    },
  ]);

  const handleSellerSubmit = (values) => {
    if (onSellerCreated) {
      onSellerCreated(values);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <HookForm
        inputs={sellerForm}
        title={'ÐÐ°Ð½Ð½ÑÐµ Ð¿ÑÐ¾Ð´Ð°Ð²ÑÐ°'}
        grid={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' }}
        handlerSetState={setSellerForm}
        onSubmit={handleSellerSubmit}
        action={'ÐÐ°Ð»ÐµÐµ'}
        border
      />
    </div>
  );
};

export default CarSellerForm; 